import "pages/transaction/transaction.scss";
import React, { useMemo } from "react";
import DetailTransactionContainer from "./detailTransaction/DetailTransactionContainer";
import FilterTransaction from "./filterTransaction/FilterTransactionContainer";
import TableTransaction from "./tableTransaction/TableTransaction";
import { TransactionType } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import { Button, SelectInput, Tooltip, ToolTipPosition } from "@pickit/pickit-components";
import AlertMasiveCancelation from "./AlertCancelation/AlertMasiveCancelation";
import { BulkCancelTransactionType } from "sagas/types/transactions";
import ExportButton from "component/exportButton/ExportButton";
import { Field, Form } from "react-final-form";
import { FilterValuesType } from "./filterTransaction/types";
import { viewResults } from "utils/constants";

export const Transaction: React.FC<TransactionType> = ({
  isExportDisabled,
  getMoreTransactions,
  getTransactionsExportRequest,
  filters,
  limit,
  seeMore,
  detailTransactionModalOpen,
  transactionsSelected,
  errorTransactions,
  masiveCancelationModalOpen,
  getTransactions,
  testId,
  cancelTransactions,
  showNotification,
  resetErrorTransactions,
  toggleMasiveCancelationModal,
}): JSX.Element => {
  const { t } = useTranslation();
  const hasErrorTransactions = useMemo(
    () => errorTransactions && errorTransactions.length > 0,
    [errorTransactions]
  );

  const handleOnChange = (limit: number) => {
    const newFiltersExtra = { offset: 0, limit }
    getTransactions({ ...filters, ...newFiltersExtra });
  }

  return (
    <>
      <div className="mainContainerFlex-transaction">
        <h2 className="subTitle-transaction">
          <p
            className="subtitle-pendingUser-h2"
            data-testId={`${testId}-title`}
          >
            {t("transactions:transactions")}
          </p>
        </h2>
        <Tooltip
          message={t("transactions:exportTooltip")}
          position={ToolTipPosition.left}
          disabled={!isExportDisabled}
        >
          <ExportButton
            disabled={isExportDisabled}
            onClick={(e) => getTransactionsExportRequest(filters, e.target)}
            testId={testId}
          />
        </Tooltip>
      </div>
      <FilterTransaction testId={`${testId}-filter`} />

      <div className="container-transaction-row">
        <Form
          onSubmit={(values: FilterValuesType) => ({ ...values })}
          keepDirtyOnReinitialize
          initialValues={{ limit }}
        >
          {({ handleSubmit, form, values }) => (
            <form
              className="form-filter-transaction"
              onSubmit={handleSubmit}
            >
              <div className="container-transaction-col-sm-1 container-transaction-custom-col-sm-1">
                <span data-testId={`${testId}-limit-label`}>
                  {t("transactions:resultsPerPage")}
                </span>
                <span className="select-results">
                  <Field
                    name="limit"
                    id="limit"
                    testId={`${testId}-limit`}
                    options={viewResults}
                    showClearIcon={false}
                    onChange={handleOnChange}
                  >
                    {(props: any) => <SelectInput {...props} />}
                  </Field>
                </span>
              </div>
              <div className="container-transaction-col-sm-2">

              </div>

              <div className="container-transaction-col-sm-1">
                <div className="transacition-masive-cancelation">
                  <div className="transacition-masive-cancelation-button">
                    <Button
                      hierarchy="primary"
                      size="medium"
                      label={t("global:cancel")}
                      disabled={transactionsSelected.length === 0}
                      onClick={() => toggleMasiveCancelationModal(true)}
                      fullWidth
                      testId={`${testId}-cancel-button`}
                    />
                  </div>
                </div>
              </div>
            </form>
          )}
        </Form>
      </div>

      <TableTransaction
        testId={`${testId}-table`}
        seeMore={seeMore}
        getMoreTransactions={getMoreTransactions}
      />
      <DetailTransactionContainer isOpen={detailTransactionModalOpen} />
      {
        <AlertMasiveCancelation
          isOpen={masiveCancelationModalOpen}
          onClose={(refresh = true) => {
            resetErrorTransactions();
            toggleMasiveCancelationModal(false);
            refresh && getTransactions({ ...filters, offset: 0 });
          }}
          onCancel={(transactions: BulkCancelTransactionType) =>
            cancelTransactions(transactions)
          }
          showNotification={showNotification}
          title={t(
            `transactions:${hasErrorTransactions
              ? errorTransactions.length < transactionsSelected.length
                ? "someTransactionsCancelTitle"
                : "errorMasiveCancelationTitle"
              : "masiveCancelationTitle"
            }`
          )}
          body={t(
            `transactions:${hasErrorTransactions
              ? transactionsSelected.length - errorTransactions.length > 1
                ? "errorMasiveCancelation"
                : "errorMasiveCancelationSingular"
              : transactionsSelected.length > 1
                ? "masiveCancelationBody"
                : "masiveCancelationBodySingular"
            }`,
            {
              amount: hasErrorTransactions
                ? transactionsSelected.length - errorTransactions.length
                : transactionsSelected.length,
            }
          )}
          errorTransactions={
            errorTransactions && errorTransactions.map((trx) => `${trx}`)
          }
          transactionsSelected={transactionsSelected}
        />
      }
    </>
  );
};
export default Transaction;
